<div class="modal">
  <app-modal-header title="my_data" [customClose]="true" (closeEventEmitter)="close()" />

  <div class="modal-content">
    <div class="container-info">
      <p class="title-info">{{ 'user' | uvetranslate }}</p>
      <div>
        @if (name || surname) {
          {{ name }} {{ surname }} -
        }
        {{ user }}
        @if (isImpersonate) {
          <span>&nbsp;{{ '[impersonate]' | uvetranslate }}</span>
        }
      </div>
    </div>

    <div class="container-info">
      <div class="info-content">
        <div>
          <p class="title-info">{{ 'version' | uvetranslate }}</p>
          <div class="version-info">
            {{ version }}
            @if (isUpdateRequired) {
              <ion-icon src="assets/icon/triangle-exclamation-light.svg" slot="start" class="triangle-update-icon" />
            } @else {
              <ion-icon src="assets/icon/circle-check-light.svg" slot="start" class="check-update-icon" />
            }
          </div>
        </div>
        @if (isUpdateRequired) {
          <ion-button mode="md" color="light" class="custom-link" shape="round" (click)="redirectToStore()">
            <ion-icon src="assets/icon/arrow-rotate-right-light.svg" slot="start" class="upload-icon" />

            {{ 'update' | uvetranslate }}
          </ion-button>
        }
      </div>
    </div>
  </div>

  <div class="modal-footer">
    <ion-button
      color="medium"
      shape="round"
      expand="block"
      fill="outline"
      [class.custom-item-disabled]="!networkService.isOnline()"
      [strong]="true"
      [attr.data-qa-id]="'button-user-logout'"
      (click)="logout()">
      <ion-icon src="assets/icon/arrow-right-from-bracket.svg" slot="start" class="menu-icon" />
      <ion-label>
        {{ 'sign_off' | uvetranslate }}
      </ion-label>
    </ion-button>
  </div>
</div>
